<div style="border: 1px solid #dddddd; padding: 10px;">
    <form [formGroup]="docsRelacionadosForm">
        <div class="row justify-content-start align-items-center">
            <div class="col-sm-12 col-md-4 col-xl-4 " *ngIf="showInput">
                <mat-form-field class="inputFullWide">
                    <mat-label>Factura Original</mat-label>
                    <input matInput formControlName="facturaOriginal" (change)="getRelatedInvoices($event)" (keyup.enter)="getRelatedInvoices($event)">
                    <mat-icon>search</mat-icon>
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-4 col-xl-4 " *ngIf="!showInput">
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Factura Original</mat-label>
                    <input type="text" id="myInvoiceInput{{index}}" matInput formControlName="facturaOriginal" [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="optionSelected($event)">
                        <ng-container *ngIf="invoicesOptions">
                            <mat-option *ngFor="let option of invoicesOptions" [value]="option">
                                <div>
                                    <label class="title">Folio:</label> {{option?.attributes?.folio}}
                                </div>
                                <div>
                                    <label class="title">Receptor:</label> {{option?.attributes?.cli_cliente?.data?.attributes?.nombre}}
                                </div>
                                <div>
                                    <label class="title">RFC:</label> {{option?.attributes?.cli_cliente?.data?.attributes?.rfc}}
                                </div>
                                <div>
                                    <label class="title">Total:</label> {{option?.attributes?.total | currency:'MXN':'symbol':'1.2-2'}}
                                </div>
                            </mat-option>
                        </ng-container>
                    </mat-autocomplete>
                    <mat-icon svgIcon="mat_solid:close" (click)="eraseRelatedInvoices()"></mat-icon>
                </mat-form-field>
            </div>

            <div class="col-sm-12 col-md-2 col-xl-2 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>Monto Original</mat-label>
                    <input matInput formControlName="montoOriginal" currencyMask>
                </mat-form-field>
            </div>
            
            <div class="col-sm-12 col-md-2 col-xl-2 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>No. Parcialidad</mat-label>
                    <input matInput formControlName="noParcialidad">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-2 col-xl-2 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>Serie (opcional)</mat-label>
                    <input matInput formControlName="serie">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-2 col-xl-2 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>Folio (opcional)</mat-label>
                    <input matInput formControlName="folio">
                </mat-form-field>
            </div>
            <br>
            <div class="col-sm-12 col-md-3 col-xl-3 ">
                <mat-form-field appearance="fill">
                    <mat-label>Moneda</mat-label>
                    <mat-select placeholder="MXN - Peso Mexicano" formControlName="monedaDocsRel"
                        (selectionChange)="changeMoneda($event.value)">
                        <mat-option *ngFor="let moneda of ltsMoneda" [value]="moneda.id">
                            {{ moneda.attributes.clave }} - {{ moneda.attributes.descripcion }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-2 col-xl-2">
                <mat-form-field appearance="fill">
                    <mat-label>Tipo de cambio</mat-label>
                    <input matInput placeholder="Tipo de cambio respecto al peso"
                        formControlName="tipoCambioDocsRel" oninput="this.value = this.value.toUpperCase()"
                        onkeypress="return ((event.charCode >= 48 && event.charCode <= 57))">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-4 col-xl-4">
                <mat-form-field appearance="fill">
                    <mat-label>Objeto impuesto</mat-label>
                    <mat-select placeholder="Selecciona una opción" formControlName="objetoImpuesto">
                        <mat-option *ngFor="let item of ltsObjetoImpuesto"
                            [value]="item.id">
                            {{item.attributes.valor}} - {{item.attributes.nombre}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
                <mat-form-field appearance="fill">
                    <mat-label>Método de pago</mat-label>
                    <mat-select placeholder="Selecciona una opción" formControlName="metodoPagoDocsRel">
                        <mat-option *ngFor="let metodoPago of ltsMetodoPago"
                            [value]="metodoPago.id">
                            {{metodoPago.attributes.clave}} - {{metodoPago.attributes.nombre}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <br>
            <div class="col-sm-12 col-md-4 col-xl-4 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>Importe Saldo Anterior</mat-label>
                    <input matInput formControlName="importeSaldoAnteriror" currencyMask>
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-4 col-xl-4 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>Importe Pagado</mat-label>
                    <input matInput formControlName="importePagado" currencyMask>
                    <mat-error *ngIf="docsRelacionadosForm?.controls?.importePagado?.invalid && docsRelacionadosForm?.controls?.importePagado?.touched">
                        {{ docError?.importePagado ?? 'El Importe Pagado es inválido.' }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-4 col-xl-4 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>Saldo Insoluto</mat-label>
                    <input matInput formControlName="saldoInsoluto" currencyMask>
                </mat-form-field>
            </div>
        </div>
    </form>

    <div class="row flex-col p-3">
        <div class="col-sm-12 col-md-12 col-xl-12">
            <span class="lblDocRel">Impuesto</span>
            <div class="row justify-content-start align-items-center">
                <div class="col-sm-1 col-md-1 col-xl-1">
                    <button (click)="addImpuesto()" class="fuse-mat-button-rounded" mat-flat-button>
                        <mat-icon>library_add</mat-icon>
                    </button>
                </div>
                <div class="col-sm-1 col-md-1 col-xl-1">
                    <button (click)="removeImpuesto()" class="fuse-mat-button-rounded"
                        mat-flat-button>
                        <mat-icon>remove_from_queue</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="row flex-col p-3">
        <div class="col-sm-12 col-md-12 col-xl-12">
            <app-impuestosComplemento
                *ngFor="let impuestos of countImpuestos"
                [lsNombre]="lsNombre"
                [idDocRelacionados]="idDocRelacionados"
                [countImpuestos]="countImpuestos.length"
                [updateDataImpuestos]="updateDataImpuestos"
                [banderaActualizarFactura]="banderaActualizarFactura"></app-impuestosComplemento>
        </div>
    </div>
</div>
<br>